"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UpdateAttributeEnumeration {
    static getAttributeTypeMap() {
        return UpdateAttributeEnumeration.attributeTypeMap;
    }
}
UpdateAttributeEnumeration.discriminator = undefined;
UpdateAttributeEnumeration.attributeTypeMap = [
    {
        "name": "value",
        "baseName": "value",
        "type": "number"
    },
    {
        "name": "label",
        "baseName": "label",
        "type": "string"
    }
];
exports.UpdateAttributeEnumeration = UpdateAttributeEnumeration;
//# sourceMappingURL=updateAttributeEnumeration.js.map